export default {
      id: "epro-eye-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#epro-eye",
      toString: function () {
        return this.url;
      }
    }